import * as types from "../actions/actionTypes";
import moment from "moment";
import * as timexHelper from "../common/helper";

const initialState = {
    isFetched: false,
    error: null,
    flightDetails: [],
    filteredFlightDetails: [],
    flightFilters: timexHelper.GetDefaultFlightFilters(),
    lastUpdate: moment(),
    serverOffSet: null,
    allFlights: [],
    allModels: [],
    allGatess: [],
    allGatess11: [],
    allStations:[],
    refreshedTime: ''
    // hubConnection: null,
    // isHubConnected: false
};

export default function flightDetailsReducer(state = initialState, action) {
    //export const reducers = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_FLIGHTDETAILS_REQUEST:
            return {
                ...state,
                isFetched: true,
            };
        case types.RESET_FLIGHT:
            return {
                ...state,
                filteredFlightDetails: [],
            };
        case types.GET_FLIGHTDETAILS_REQUEST_DONE:
            return {
                ...state,
                isFetched: false,
            };

        case types.GET_FLIGHTDETAILS_SUCCESS:
            return {
                ...state,
                isFetched: false,
                lastUpdate: action.lastUpdate,
                flightFilters: initialState.flightFilters,
                serverOffSet: action.serverOffSet,
                allFlights: action.allFlights,
                allFlightsData: action.allFlightsData,
                allModels: action.allModels,
                allGatess: action.allGatess,
                allGatess11: action.allGatess11,
            };

        case types.GET_FLIGHTDETAILS_FAIL:
            return {
                ...state,
                isFetched: false,
                error: action.payload,
            };

    case types.SET_FLIGHTDETAILS:
      return {
        ...state,
        flightDetails: action.flightDetail,
        filteredFlightDetails: action.filteredFlightDetails,
        flightFilters: action.flightFilter,  
        allFlights: action.allFlights,
        allFlightsData: action.allFlightsData,
        allModels: action.allModels,
        allGatess: action.allGatess,
        allGatess11:action.allGatess11,
        refreshedTime: action.refreshedTime
    }

        case types.FILTER_STATION:
            return {
                ...state,
                station: action.station,
            };

        case types.DATA_RECEIVED:
            return {
                ...state,
                lastUpdate: action.lastUpdate,
            };
        // case HUB_CONNECTION_REQUEST:
        //   return {
        //     ...state,
        //     isHubConnected: false
        //   }

        // case HUB_CONNECTION_ON_CONNECTED:
        //   return {
        //     ...state,
        //     isHubConnected: true
        //   }

        // case HUB_CONNECTION_ON_DISCONNECTED:
        //     return {
        //       ...state,
        //       isHubConnected: false
        //     }

        default:
            return state;
    }
}

//export default flightDetailsReducer
